/**
 * Second product picture of a list tile, shown on hover (desktop) — loaded only then.
 *
 * The tile carries the url in data-hover-src instead of src: `loading="lazy"` does not help
 * here, a lazy image inside the viewport is fetched right away, so every visible tile used to
 * download its second picture whether anyone hovered or not. Delegated listeners, so tiles
 * added later (sliders, "load more") work without re-binding.
 */
const SELECTOR = '.product-card img[data-hover-src]';

function loadHoverImage(event) {
    const card = event.target instanceof Element ? event.target.closest('.product-card') : null;
    const img = card ? card.querySelector(SELECTOR) : null;
    if (!img) {
        return;
    }
    img.src = img.dataset.hoverSrc;
    img.removeAttribute('data-hover-src');
}

document.addEventListener('mouseover', loadHoverImage, { passive: true });
document.addEventListener('focusin', loadHoverImage);
